import type { ProcessingState } from "@redux/state/shared-types";
import { refuseExternalProviderPayment, resetRefuseExternalProviderPayment } from "./refuse-external-provider-payment";
import { createReducer } from "@reduxjs/toolkit";

const initialState: ProcessingState = { processing: "idle" };

export const refuseExternalProviderPaymentReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(refuseExternalProviderPayment.fulfilled, state => {
      return {
        ...state,
        processing: "success",
      };
    })
    .addCase(refuseExternalProviderPayment.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(refuseExternalProviderPayment.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetRefuseExternalProviderPayment, () => {
    return initialState;
  });
});
